const DEFAULT_PRODUCTION_SURVEY_URL = 'https://survey.responsedock.com';

function stripTrailingSlash(value: string): string {
  return value.replace(/\/+$/, '');
}

export function getWebSurveyBaseUrl(): string {
  const configured = import.meta.env.VITE_WEB_SURVEY_URL?.trim();
  if (configured) return stripTrailingSlash(configured);

  const origin = stripTrailingSlash(window.location.origin);
  if (origin === 'https://app.responsedock.com') return DEFAULT_PRODUCTION_SURVEY_URL;

  return origin
    .replace(':5173', ':5174')
    .replace(':4001', ':5174')
    .replace(':3000', ':5174');
}

export function getSurveyShareUrl(slug: string, workspaceSlug?: string | null): string {
  const encodedSlug = encodeURIComponent(slug);
  if (workspaceSlug) {
    return `${getWebSurveyBaseUrl()}/w/${encodeURIComponent(workspaceSlug)}/s/${encodedSlug}`;
  }
  return `${getWebSurveyBaseUrl()}/s/${encodedSlug}`;
}

export function getSurveyResultsUrl(slug: string, workspaceSlug?: string | null): string {
  return `${getSurveyShareUrl(slug, workspaceSlug)}/results`;
}

export function getSurveyPreviewUrl(slug: string, previewToken?: string, workspaceSlug?: string | null): string {
  const url = new URL(getSurveyShareUrl(slug, workspaceSlug));
  url.searchParams.set('preview', '1');
  if (previewToken) url.searchParams.set('previewToken', previewToken);
  return url.toString();
}
